<template>
  <div>
    <vue-dropzone
      class="mt-5"
      ref="myVueDropzone"
      id="dropzone"
      :options="dropzoneOptions"
      v-on:vdropzone-sending="setAuthHeader"
      v-on:vdropzone-success="uploadSuccess"
      v-on:vdropzone-removed-file="handleRemove"
      v-on:vdropzone-complete="handleMaxFile"
    ></vue-dropzone>
    <v-card class="my-5" color="green lighten-3">
      <v-card-text
        v-if="uploadResponse"
      >Fichier valide contenant {{uploadResponse ? uploadResponse.count : 0}} lignes</v-card-text>
    </v-card>
    <div class="text-xs-center ma-5">
      <v-btn
        :disabled="!uploadResponse"
        round
        color="primary"
        @click="saveAndClearUpload(uploadResponse)"
      >Sauvegarder</v-btn>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  props: ["saveUpload"],
  name: "uploader",
  components: {
    vueDropzone: vue2Dropzone,
  },
  mounted() {
    this.$refs.myVueDropzone.setOption("accept", this.acceptFile);
  },
  methods: {
    setAuthHeader: function (file, xhr) {
      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${this.$keycloak.token}`
      );
    },
    uploadSuccess: function (file, response) {
      this.uploadResponse = response;
    },
    saveAndClearUpload: function (uploadResponse) {
      const { enable, removeAllFiles } = this.$refs.myVueDropzone;
      this.uploadResponse = undefined;
      this.saveUpload(uploadResponse);
      removeAllFiles();
      enable();
    },
    handleRemove: function () {
      this.uploadResponse = undefined;
      this.$refs.myVueDropzone.enable();
    },
    handleMaxFile: function () {
      const { getAcceptedFiles, getRejectedFiles } = this.$refs.myVueDropzone;
      if (getAcceptedFiles().length || getRejectedFiles().length) {
        this.$refs.myVueDropzone.disable();
      }
    },
    acceptFile: function (file, done) {
      if (file.name !== this.$route.name) {
        done("Mauvais fichier choisi.");
        return;
      }
      this.$keycloak
        .updateToken(30)
        .then(() => done())
        .catch(() => this.$keycloak.login());
    },
  },
  data: function () {
    return {
      route: this.$route.name,
      uploadResponse: undefined,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URI}/upload`,
        thumbnailWidth: 150,
        maxFilesize: 5,
        addRemoveLinks: true,
        dictDefaultMessage: this.$route.name,
        dictCancelUpload: "Annuler",
        dictRemoveFile: "Supprimer",
        dictMaxFilesExceeded: "Un seul fichier peut être ajouté",
        maxFiles: 1,
      },
    };
  },
  watch: {
    $route: async function (to) {
      const { removeAllFiles } = this.$refs.myVueDropzone;
      this.uploadResponse = undefined;
      removeAllFiles();
      this.route = to.name;
      document.getElementsByClassName(
        "dz-default dz-message"
      )[0].innerHTML = `<span>${to.name}</span>`;
    },
  },
};
</script>

<style>
div.dz-preview {
  z-index: 2 !important;
}
.vue-dropzone > .dz-preview .dz-details {
  background-color: #78909c;
}
.dz-message > span {
  font-size: 1.3em;
}
</style>

